export default __webpack_public_path__ + "static/media/likhilesh_instructor.898ec465.jpeg";